import React, { Component } from "react";
import swal from 'sweetalert';
import { toast } from "react-toastify";
import AddSharpIcon from '@material-ui/icons/AddSharp';
import SearchSharpIcon from '@material-ui/icons/SearchSharp';
import MoreVertSharpIcon from "@material-ui/icons/MoreVertSharp";
import { FormControl, Button, InputGroup, Table, Form, Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap';

import axios from '../../../axios';
import apiError from '../../../error';
import { debounce, getCookie } from "../../../function";
import AddUserModal from '../../../component/iam/add-user/add-user';
import './iamuser.css';
import Pagination from "react-js-pagination";


export default class IamUser extends Component {
    constructor(props) {
        super(props);
        this.isTAconnected = getCookie('isTAconnected');
        this.isTASyncing = getCookie('isTASyncing');
        this.state = {
            employees: [],
            show: false,
            search: '',
            limit: 10,
            count: 0,
            activePage: 1
        }
        this.load();
    }

    handleModal = () => {
        this.setState({ show: !this.state.show })
    }

    nextPath = path => this.props.history.push(path);

    load = debounce(() => {
        axios.get('/api/iam-user/', {
            params: {
                search: this.state.search,
                limit: this.state.limit,
                page: this.state.activePage
            }
        })
            .then(res => {
                this.setState({ employees: res.data.employees, count: res.data.count })
            })
            .catch(err => apiError(err))
    }, 500)

    deleteUser = (userId) => {
        swal({
            title: "Do You Want To Delete User?",
            icon: "warning",
            buttons: ['No', 'Yes'],
        })
            .then(willSuccess => {
                if (willSuccess) {
                    axios.delete('/api/iam-user/delete/' + userId, {})
                        .then(res => {
                            toast.success("User Deleted Successfully");
                            this.load();
                        })
                        .catch(err => apiError(err))
                }
            });
    }
    handleRedirectToTAAddUser = async () => {
        try {
            const response = await axios.post('/api/redirect/', {
                urlName: "addIAMUser"
            });
            window.location.replace(`${response.data.url}?appName=TSAT&action=iam`);
        } catch (error) {
            apiError(error);
        }
    }

    render() {
        return (
            <div className="content-wrap">
                <div className="breadcrumbbar">
                    <div className="flexRow row">
                        <div className="col-md-4">
                            <div className="page-head d-flex align-items-center justify-content-between">
                                <h4 className="page-title">Users</h4>
                            </div>
                        </div>
                        <div className="col-md-8 flexFilterButtons">
                            <div className="btn-container float-right d-flex align-items-center">
                                <OverlayTrigger
                                    placement="top"
                                    overlay={
                                        this.isTASyncing ? (
                                            <Tooltip id="top"> <span>Threatcop Admin Sync is already in progress</span>
                                            </Tooltip>
                                        ) : (
                                            <Tooltip id="top" className="d-none" />
                                        )
                                    }
                                >
                                    <Button className={`btn-primary ${this.isTASyncing && 'disabledCls2'}`} onClick={
                                        this.isTAconnected ? !this.isTASyncing ? this.handleRedirectToTAAddUser : undefined : !this.isTASyncing ? this.handleModal : undefined
                                    }><AddSharpIcon className="btn-icon"></AddSharpIcon> Add User</Button>
                                </OverlayTrigger>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="contentbar">
                    <div className="filter-without-border">
                        <div className="align-items-center row">
                            <div className="col-md-3">
                                <div className="positionSearchIcon">
                                    <InputGroup className="search-wrap">
                                        <FormControl type="text" placeholder="Search" value={this.state.search} onChange={e => this.setState({ search: e.target.value }, () => this.load())} className="inputSearch mr-sm-2 form-control" /><SearchSharpIcon className="search-icon"></SearchSharpIcon>
                                    </InputGroup>
                                </div>
                            </div>

                            <div className="col-md-9">
                                <div className="rightFilters">

                                    <Dropdown className="d-inline-block">
                                        <Dropdown.Toggle variant="secondary" id="limit-dropdown" className="dropdown-color-white">
                                            {this.state.limit}
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            {[10, 25, 50, 100].map((limit) => (
                                                <Dropdown.Item
                                                    key={`limit-${limit}`}
                                                    onClick={() => this.setState({ limit: limit, activePage: 1 }, () => this.load())}
                                                    active={this.state.limit === limit}
                                                >
                                                    {limit}
                                                </Dropdown.Item>
                                            ))}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                            </div>
                        </div>
                    </div>
                    {this.state.employees.length > 0 ?
                        <div className="tableContainerWrapInner">
                            <Table responsive className="mb-0">
                                <thead className="bg-light">
                                    <tr>
                                        <th>Id</th>
                                        <th>First Name</th>
                                        <th>Last Name</th>
                                        <th>Email</th>
                                        {this.isTAconnected && <th>Role</th>}
                                        {!this.isTAconnected && <th>Action</th>}
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.employees.map((employee, index) => {
                                        return <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{employee.firstname}</td>
                                            <td>{employee.lastname ? employee.lastname : '---'}</td>
                                            <td>{employee.email}</td>
                                            {this.isTAconnected && <td>{(employee?.userPolicies && employee.userPolicies.length > 0 && employee.userPolicies[0].role?.name) || "---"}</td>}
                                            {!this.isTAconnected &&
                                                <td>
                                                    <Dropdown
                                                        className="action-dropdown dropdownIcon" ref={this.selectRef}>
                                                        <Dropdown.Toggle className="btn-only" id="dropdown-basic">
                                                            <MoreVertSharpIcon className="dot-icon"></MoreVertSharpIcon>
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu>
                                                            <Dropdown.Item onClick={e => this.nextPath('/iam/users/' + employee.id)}>Edit</Dropdown.Item>
                                                            <OverlayTrigger
                                                                placement="top"
                                                                overlay={
                                                                    this.isTASyncing ? (
                                                                        <Tooltip id="top"> <span>Threatcop Admin Sync is already in progress</span>
                                                                        </Tooltip>
                                                                    ) : (
                                                                        <Tooltip id="top" className="d-none" />
                                                                    )
                                                                }
                                                            >
                                                                <Dropdown.Item className={`${this.isTASyncing && "disabledCls3"}`} onClick={e => { if (!this.isTASyncing) return this.deleteUser(employee.id) }} >Delete</Dropdown.Item>
                                                            </OverlayTrigger>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </td>
                                            }

                                        </tr>
                                    })}
                                </tbody>
                            </Table>
                            <div className="pagination-Wrap">
                                <div className="row">
                                    <div className="col-md-6">
                                        <Pagination
                                            itemClass="page-item"
                                            linkClass="page-link"
                                            activePage={this.state.activePage}
                                            itemsCountPerPage={this.state.limit}
                                            totalItemsCount={this.state.count}
                                            onChange={(pageNumber) => this.setState({ activePage: pageNumber }, () => this.load())}
                                        />
                                    </div>
                                    <div className="col-md-6 text-right d-flex align-items-center footer-pg">
                                        <div className="w-100 pgCount">
                                            <p>
                                                {this.state.count === 0
                                                    ? 0
                                                    : this.state.activePage * this.state.limit + 1 - this.state.limit}
                                                -
                                                {this.state.activePage * this.state.limit > this.state.count
                                                    ? this.state.count
                                                    : this.state.activePage * this.state.limit}{" "}
                                                of {this.state.count} records
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> : <h6>No user found</h6>
                    }

                    <AddUserModal
                        load={this.load}
                        show={this.state.show}
                        handleModal={this.handleModal}
                    ></AddUserModal>
                </div>
            </div>
        );
    }
}